import axios from 'axios';

const api = axios.create({
    baseURL: 'https://streamingappapi.gaelprod974.re/api'
    //baseURL: 'http://localhost:5000/api'

});

// Ajout automatique du token s'il existe
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;